import React, { memo } from "react";
import { Select, Typography } from "antd";

const { Title } = Typography;
const { Option } = Select;

export default memo(function SelectFilter({
    title,
    placeholder = "Select an option",
    value,
    defaultLabel,
    onChange,
    onSearch,
    options = [],
    mode,
    disabled = false,
    allowClear = true,
    showSearch = true,
    loading = false,
    size = "middle",
    className = "",
    style = {},
    filterOption = true,
    notFoundContent = "No options found",
    showValue = (option) => option.label,
    getValue,
    containerClassName = "",
    label = 'abc',
    labelClassNameTop = 'block font-medium text-black',
}) {
    const handleChange = (selectedValue, option) => {
        onChange?.(selectedValue, option);
    };

    const handleSearch = (searchValue) => {
        onSearch?.(searchValue);
    };

    const defaultFilterOption = (input, option) => {
        const label = option.children?.toLowerCase() || "";
        const value = option.value?.toString().toLowerCase() || "";
        const searchTerm = input.toLowerCase();
        return label.includes(searchTerm) || value.includes(searchTerm);
    };

    return (
        <div className={`relative ${containerClassName}`}>
            <div className="text-start">
                {label ? (
                    <label htmlFor={label + title} className={labelClassNameTop}>
                        {label}
                    </label>
                ) : null}
            </div>
            <div className={`relative ${containerClassName}`}>
                {title && (
                    <Title level={5} style={{ marginBottom: 8 }}>
                        {title}
                    </Title>
                )}

                <Select
                    value={value || undefined}
                    onChange={handleChange}
                    onSearch={handleSearch}
                    placeholder={defaultLabel || placeholder}
                    mode={mode}
                    disabled={disabled}
                    allowClear={allowClear}
                    showSearch={showSearch}
                    loading={loading}
                    size="large"
                    className={`w-full select-left-placeholder ${className}`}
                    style={{
                        height: '40px',
                        borderRadius: '4px',
                        borderColor: '#9CA3AF',
                        ...style
                    }}
                    filterOption={filterOption === true ? defaultFilterOption : filterOption}
                    notFoundContent={loading ? "Searching..." : notFoundContent}
                >
                    {options.map((option, index) => (
                        <Option
                            key={option.value || index}
                            value={getValue(option)}
                            disabled={option.disabled}
                        >
                            {showValue(option)}
                        </Option>
                    ))}
                </Select>

            </div>
        </div>
    );
})
